import React from 'react'
import { useNavigate } from 'react-router-dom'
import './DownloadPage.css'

const DownloadPage: React.FC = () => {
  const navigate = useNavigate()

  const handleAndroid = () => {
    // Replace with actual Android download URL or app store link
    const url = process.env.REACT_APP_ANDROID_URL || '#'
    if (url !== '#') window.open(url, '_blank', 'noopener,noreferrer')
    else alert('Tautan unduhan Android sedang diperbarui. Hubungi LINE: @037zpchz')
  }

  const handleIOS = () => {
    // Replace with actual iOS App Store URL
    const url = process.env.REACT_APP_IOS_URL || '#'
    if (url !== '#') window.open(url, '_blank', 'noopener,noreferrer')
    else alert('Tautan unduhan iOS sedang diperbarui. Hubungi LINE: @037zpchz')
  }

  return (
    <div className="dl-root">
      {/* Header */}
      <header className="dl-header">
        <div className="dl-header-inner">
          <div className="dl-logo">
            <span>🇮🇩</span>
            <span className="dl-logo-text">Pinjaman Kilat</span>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="dl-hero">
        <div className="dl-hero-content">
          <div className="dl-success-badge">
            <div className="dl-success-icon">✓</div>
            <span>Berhasil masuk!</span>
          </div>
          <h1 className="dl-hero-title">
            Unduh Aplikasi<br />
            <span className="dl-hero-accent">Pinjaman Kilat</span>
          </h1>
          <p className="dl-hero-desc">
            Unduh aplikasi untuk mengajukan pinjaman, memantau status,
            melakukan pembayaran, dan mengelola akun kapan saja.
          </p>

          {/* Download Buttons */}
          <div className="dl-buttons">
            <button className="dl-btn dl-btn-android" onClick={handleAndroid}>
              <div className="dl-btn-icon">
                <AndroidIcon />
              </div>
              <div className="dl-btn-text">
                <span className="dl-btn-label">Unduh untuk</span>
                <span className="dl-btn-store">Android</span>
              </div>
              <div className="dl-btn-arrow">→</div>
            </button>

            <button className="dl-btn dl-btn-ios" onClick={handleIOS}>
              <div className="dl-btn-icon">
                <AppleIcon />
              </div>
              <div className="dl-btn-text">
                <span className="dl-btn-label">Unduh untuk</span>
                <span className="dl-btn-store">iOS (iPhone / iPad)</span>
              </div>
              <div className="dl-btn-arrow">→</div>
            </button>
          </div>

          <p className="dl-hint">
            💡 Android: Unduh APK langsung atau melalui Google Play Store<br />
            🍎 iOS: Tersedia dengan mudah melalui App Store
          </p>
        </div>

        {/* Mockup */}
        <div className="dl-visual">
          <div className="dl-phone-wrap">
            <div className="dl-phone">
              <div className="dl-phone-notch" />
              <div className="dl-phone-screen">
                <div className="dl-app-header">
                  <span className="dl-app-logo">🇮🇩</span>
                  <span className="dl-app-name">Pinjaman Kilat</span>
                </div>
                <div className="dl-app-amount-label">Limit Saya</div>
                <div className="dl-app-amount">Rp7.500.000</div>
                <div className="dl-app-tag">✓ Siap Digunakan</div>
                <div className="dl-app-menu">
                  <div className="dl-app-menu-item">
                    <span>💳</span><span>Pinjam</span>
                  </div>
                  <div className="dl-app-menu-item">
                    <span>📊</span><span>Bayar</span>
                  </div>
                  <div className="dl-app-menu-item">
                    <span>📋</span><span>Riwayat</span>
                  </div>
                  <div className="dl-app-menu-item">
                    <span>👤</span><span>Akun</span>
                  </div>
                </div>
                <div className="dl-app-banner">
                  <div>Promo Spesial</div>
                  <div className="dl-app-banner-sub">Biaya transparan sebelum persetujuan</div>
                </div>
              </div>
            </div>
            <div className="dl-phone-shadow" />
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="dl-features">
        <div className="dl-features-inner">
          <h2 className="dl-features-title">Mengapa Menggunakan Aplikasi?</h2>
          <div className="dl-features-grid">
            {[
              { icon: '⚡', title: 'Pengajuan Cepat', desc: 'Proses persetujuan otomatis hanya dalam beberapa menit.' },
              { icon: '🔔', title: 'Notifikasi Langsung', desc: 'Dapatkan informasi status pinjaman dan tagihan.' },
              { icon: '💸', title: 'Pembayaran Mudah', desc: 'Bayar langsung melalui berbagai metode di aplikasi.' },
              { icon: '📈', title: 'Pantau Status', desc: 'Lihat rincian dan riwayat pinjaman selama 24 jam.' },
            ].map((f) => (
              <div className="dl-feature-card" key={f.title}>
                <div className="dl-feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* QR / Info */}
      <section className="dl-info">
        <div className="dl-info-inner">
          <div className="dl-info-box">
            <h3>Butuh Bantuan?</h3>
            <p>Hubungi tim Pinjaman Kilat melalui</p>
            <div className="dl-info-line">
              <span className="dl-info-line-icon">💬</span>
              <span>LINE: <strong>@037zpchz</strong></span>
            </div>
            <div className="dl-info-line">
              <span className="dl-info-line-icon">🕐</span>
              <span>Jam layanan: Senin–Minggu, 08.00–20.00 WIB</span>
            </div>
          </div>
          <div className="dl-info-box">
            <h3>Informasi Aplikasi</h3>
            <div className="dl-info-list">
              <div className="dl-info-row"><span>Versi</span><span>1.0.0</span></div>
              <div className="dl-info-row"><span>Ukuran Android</span><span>~25 MB</span></div>
              <div className="dl-info-row"><span>Ukuran iOS</span><span>~30 MB</span></div>
              <div className="dl-info-row"><span>Bahasa</span><span>Bahasa Indonesia</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="dl-footer">
        <div className="dl-footer-inner">
          <div className="dl-footer-logo">
            <span>🇮🇩</span>
            <span>Pinjaman Kilat</span>
          </div>
          <p className="dl-footer-legal">
            © 2026 Pinjaman Kilat Indonesia | Manfaat ekonomi maks. 0,3% per hari untuk tenor konsumtif hingga 6 bulan
          </p>
          <div className="dl-footer-links">
            <a href="/terms">Syarat dan Ketentuan</a>
            <span>·</span>
            <a href="/privacy">Kebijakan Privasi</a>
            <span>·</span>
            <button
              className="dl-footer-btn-link"
              onClick={() => navigate('/')}
            >
              Beranda
            </button>
          </div>
        </div>
      </footer>
    </div>
  )
}

function AndroidIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.523 15.341c-.54 0-.977-.437-.977-.977s.437-.977.977-.977.977.437.977.977-.437.977-.977.977m-11.046 0c-.54 0-.977-.437-.977-.977s.437-.977.977-.977.977.437.977.977-.437.977-.977.977m11.4-6.588l1.953-3.382a.407.407 0 0 0-.149-.557.407.407 0 0 0-.557.149l-1.977 3.424A11.81 11.81 0 0 0 12 7.5c-1.703 0-3.315.376-4.747 1.047L5.276 5.123a.407.407 0 0 0-.557-.149.407.407 0 0 0-.149.557l1.953 3.382C3.877 10.405 2.25 12.837 2.25 15.75h19.5c0-2.913-1.627-5.345-3.873-6.997" />
    </svg>
  )
}

function AppleIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11"/>
    </svg>
  )
}

export default DownloadPage
